export var GET_STORE_TIMINGS = '[Stores] Get Store Timings';
export var GET_STORE_TIMINGS_SUCCESS = '[Stores] Get Store Timings Success';
export var GET_STORE_TIMINGS_ERROR = '[Stores] Get Store Timings Error';
export var ADD_NEW_TIMING = '[Stores] Add New Timing';
export var ADD_NEW_TIMING_SUCCESS = '[Stores] Add New Timing Success';
export var ADD_NEW_TIMING_ERROR = '[Stores] Add New Timing Error';
export var UPDATE_STORE_TIMINGS = '[Stores] Update Store Timings';
export var UPDATE_STORE_TIMIMGS_SUCCESS = '[Stores] Update Store Timings Success';
export var UPDATE_STORE_TIMINGS_ERROR = '[Stores] Update Store Timings Error';
export var GET_STORE_DETAILS = '[Stores] Get Store Details';
export var GET_STORE_DETAILS_SUCCESS = '[Stores] Get Store Details Success';
export var GET_STORE_DETAILS_ERROR = '[Stores] Get Store Details Error';
export var UPDATE_STORE_DETAILS = '[Stores] Update Store Details';
export var UPDATE_STORE_DETAILS_SUCCESS = '[Stores] Update Store Details Success';
export var UPDATE_STORE_DETAILS_ERROR = '[Stores] Update Store Details Error';
var GetStoreTimings = /** @class */ (function () {
    function GetStoreTimings(payload) {
        this.payload = payload;
        this.type = GET_STORE_TIMINGS;
    }
    return GetStoreTimings;
}());
export { GetStoreTimings };
var GetStoreTimingsSuccess = /** @class */ (function () {
    function GetStoreTimingsSuccess(payload) {
        this.payload = payload;
        this.type = GET_STORE_TIMINGS_SUCCESS;
    }
    return GetStoreTimingsSuccess;
}());
export { GetStoreTimingsSuccess };
var GetStoreTimingsError = /** @class */ (function () {
    function GetStoreTimingsError(payload) {
        this.payload = payload;
        this.type = GET_STORE_TIMINGS_ERROR;
    }
    return GetStoreTimingsError;
}());
export { GetStoreTimingsError };
var AddNewTiming = /** @class */ (function () {
    function AddNewTiming(payload) {
        this.payload = payload;
        this.type = ADD_NEW_TIMING;
    }
    return AddNewTiming;
}());
export { AddNewTiming };
var AddNewTimingSuccess = /** @class */ (function () {
    function AddNewTimingSuccess(payload) {
        this.payload = payload;
        this.type = ADD_NEW_TIMING_SUCCESS;
    }
    return AddNewTimingSuccess;
}());
export { AddNewTimingSuccess };
var AddNewTimingError = /** @class */ (function () {
    function AddNewTimingError(payload) {
        this.payload = payload;
        this.type = ADD_NEW_TIMING_ERROR;
    }
    return AddNewTimingError;
}());
export { AddNewTimingError };
var GetStoreDetails = /** @class */ (function () {
    function GetStoreDetails(payload) {
        this.payload = payload;
        this.type = GET_STORE_DETAILS;
    }
    return GetStoreDetails;
}());
export { GetStoreDetails };
var GetStoreDetailsSuccess = /** @class */ (function () {
    function GetStoreDetailsSuccess(payload) {
        this.payload = payload;
        this.type = GET_STORE_DETAILS_SUCCESS;
    }
    return GetStoreDetailsSuccess;
}());
export { GetStoreDetailsSuccess };
var GetStoreDetailsError = /** @class */ (function () {
    function GetStoreDetailsError(payload) {
        this.payload = payload;
        this.type = GET_STORE_DETAILS_ERROR;
    }
    return GetStoreDetailsError;
}());
export { GetStoreDetailsError };
var UpdateStoreTimings = /** @class */ (function () {
    function UpdateStoreTimings(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_TIMINGS;
    }
    return UpdateStoreTimings;
}());
export { UpdateStoreTimings };
var UpdateStoreTimingsSuccess = /** @class */ (function () {
    function UpdateStoreTimingsSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_TIMIMGS_SUCCESS;
    }
    return UpdateStoreTimingsSuccess;
}());
export { UpdateStoreTimingsSuccess };
var UpdateStoreTimingsError = /** @class */ (function () {
    function UpdateStoreTimingsError(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_TIMINGS_ERROR;
    }
    return UpdateStoreTimingsError;
}());
export { UpdateStoreTimingsError };
var UpdateStoreDetails = /** @class */ (function () {
    function UpdateStoreDetails(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_DETAILS;
    }
    return UpdateStoreDetails;
}());
export { UpdateStoreDetails };
var UpdateStoreDetailsSuccess = /** @class */ (function () {
    function UpdateStoreDetailsSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_DETAILS_SUCCESS;
    }
    return UpdateStoreDetailsSuccess;
}());
export { UpdateStoreDetailsSuccess };
var UpdateStoreDetailsError = /** @class */ (function () {
    function UpdateStoreDetailsError(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_DETAILS_ERROR;
    }
    return UpdateStoreDetailsError;
}());
export { UpdateStoreDetailsError };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/store/actions/settings.action.ts.pre-build-optimizer.js